import type { RJSFSchema, UiSchema as RjsfUiSchema } from "@rjsf/utils";

export const normalizeUiSchema = (
  raw: unknown,
  schema?: RJSFSchema
): RjsfUiSchema => {
  if (!raw || typeof raw !== "object") return {};

  const cloned: any = { ...(raw as any) };

  Object.entries(cloned).forEach(([key, value]) => {
    if (!value || typeof value !== "object") return;

    // Skip top-level "ui:*" entries such as "ui:order", "ui:submitButtonOptions"
    if (key.startsWith("ui:")) return;

    const v = value as any;
    const options = v["ui:options"];

    if (
      options &&
      typeof options === "object" &&
      options.widget &&
      !v["ui:widget"]
    ) {
      const widget = options.widget as string;

      v["ui:widget"] = widget;

      // Avoid having two sources of truth (RJSF reads ui:widget).
      delete options.widget;
    }
  });

  return cloned as RjsfUiSchema;
};
